import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './config';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore } from '@firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBt0abwo57REZblpzFVCypr6gjwt0LPVv4",
  authDomain: "etherfrensdapp.firebaseapp.com",
  projectId: "etherfrensdapp",
  storageBucket: "etherfrensdapp.appspot.com",
  messagingSenderId: "146364834843",
  appId: "1:146364834843:web:a4b1374631f8b4488ac4be",
  measurementId: "G-DXE7TJP50N"
});

  // Initialize Firebase
const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);

// detech auth state
onAuthStateChanged(auth, user  => {
  if (user != null ) {
    console.log("Logged in!");
  } else {
    console.log("No user");
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <App/>
  </React.StrictMode>
);